import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import MuiAccordion from '@material-ui/core/Accordion';
import MuiAccordionSummary from '@material-ui/core/AccordionSummary';
import MuiAccordionDetails from '@material-ui/core/AccordionDetails';
import Typography from '@material-ui/core/Typography';

import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

const CustomAccordion = withStyles({
	root: {
		width: '100%'
	}
})(MuiAccordion);

const CustomLargeAccordionSummary = withStyles(theme => ({
	root: {
		paddingLeft: theme.spacing(3),
		minHeight: '30px',
		'&$expanded': {
			minHeight: '30px'
		}
	},
	content: {
		margin: `${theme.spacing(2)}px 0`,
		'&$expanded': {
			margin: `${theme.spacing(2)}px 0`
		}
	},
	expanded: {}
}))(MuiAccordionSummary);

const CustomAccordionSummary = withStyles(theme => ({
	root: {
		paddingLeft: theme.spacing(3),
		minHeight: '30px',
		'&$expanded': {
			minHeight: '30px'
		}
	},
	content: {
		margin: 0,
		'&$expanded': {
			margin: 0
		}
	},
	expanded: {}
}))(MuiAccordionSummary);

const CustomAccordionDetails = withStyles(theme => ({
	root: {
		padding: `0 ${theme.spacing(3)}px`
	}
}))(MuiAccordionDetails);

const Accordion = ({ title, content, variant, ...rest }) => (
	<CustomAccordion elevation={0} {...rest}>
		{variant === 'small' ? (
			<CustomAccordionSummary expandIcon={<ExpandMoreIcon fontSize="small" />}>
				<Typography variant="body2" color="textSecondary">
					{title}
				</Typography>
			</CustomAccordionSummary>
		) : variant === 'large' ? (
			<CustomLargeAccordionSummary expandIcon={<ExpandMoreIcon />}>
				<Typography variant="h6">{title}</Typography>
			</CustomLargeAccordionSummary>
		) : (
			<CustomAccordionSummary expandIcon={<ExpandMoreIcon />}>
				<Typography variant="body2" color="textSecondary">
					{title}
				</Typography>
			</CustomAccordionSummary>
		)}

		<CustomAccordionDetails>{content}</CustomAccordionDetails>
	</CustomAccordion>
);

Accordion.propTypes = {
	title: PropTypes.string.isRequired,
	content: PropTypes.node.isRequired,
	variant: PropTypes.string
};

export default Accordion;
